<!-- 了解详情 -->
<template>
  <div class="main-news">
    <div class="news-title">
      {{newsData.contentTitle}}
    </div>
    <div class="news-title-small">
      {{newsData.contentDate}}&nbsp;&nbsp;作者：{{newsData.contentAuthor}}
    </div>
    <div class="news-content"
         v-html="newsData.publishContent">
    </div>
    <!-- <div class="news-content">
      别急，这还有一项重要事项需要完成！
    </div>
    <div class="news-img"
         style="margin-top:60px;">
      <img alt="" src="../../assets/img/news1.png" />
    </div>
    <div class="news-img">
      <img alt="" src="../../assets/img/news2.png" />
    </div>
    <div class="news-img">
      <img alt="" src="../../assets/img/news3.png" />
    </div>
    <div class="news-img">
      <img alt="" src="../../assets/img/news5.png" />
    </div>
    <div class="news-content">
    </div> -->
    <div class="button">
      <el-button size="medium"
                 type="primary"
                 class="backButton"
                 @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data() {
    return {
      img1: '../../assets/img/banner1.jpg',
      newsData: {}
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.$request.get(`/sys/commcontent/info/${this.$route.query.newsId}`).then((res, total, code, data) => {
      this.newsData = res
      this.newsData.contentDate = Vue.filter('formatDateNoTime')(this.newsData.contentDate)
    }).catch(() => { })
  }
}
</script>

<style lang="scss" scoped>
.main-news {
  overflow: hidden;
  // height: 400px;
  width: 1200px;
  margin: 0 auto;
  margin-top: 70px;
}
.news-title {
    font-weight: bold;
  text-align: center;
  font-size: 24px;
}
.news-title-small {
  text-align: center;
  margin-top: 30px;
}
.news-content {
  margin-top: 19px;
  min-height: 400px;
}
.news-img {
  text-align: center;
}
.news-img img {
  width: 1200px;
}
.button {
  margin: 20px auto;
  width: 160px;
  .backButton {
    width: 160px;
    height: 36px;
    font-size: 14px;
  }
}
</style>
